import { Grid } from "@mui/material"
import { KpiCard } from "./KpiCard"
import { badgeColor, fmtNum } from "../utils/analyzeStats"
import type { ChatAnalyze } from "../interfaces"

interface KpiGridProps {
  stats: ChatAnalyze.Stats
}

export function KpiGrid({ stats }: KpiGridProps) {
  const msgsPerDay = stats.totalDays ? stats.total / stats.totalDays : 0

  const cards = [
    {
      title: "Уникальных авторов (люди)",
      value: fmtNum(stats.allUsersCount - stats.botUsersCount),
      subtitle: "за весь период",
      color: "default" as const,
    },
    {
      title: "DAU (авторов/день)",
      value: fmtNum(stats.avgDau, 1),
      subtitle: "норма: ≥10",
      color: badgeColor(stats.avgDau, 10, 5, 0, false),
    },
    {
      title: "WAU (авторов/неделю)",
      value: fmtNum(stats.avgWau, 1),
      subtitle: "норма: ≥20",
      color: badgeColor(stats.avgWau, 20, 10, 0, false),
    },
    {
      title: "MAU (авторов/месяц)",
      value: fmtNum(stats.avgMau, 1),
      subtitle: "общий охват за месяц",
      color: "default" as const,
    },
    {
      title: "Stickiness (DAU/MAU)",
      value: `${fmtNum(stats.stickiness, 1)}%`,
      subtitle: "TG-норма 10–35%",
      color: badgeColor(stats.stickiness, 15, 8, 0, false),
    },
    {
      title: "Сообщений/день",
      value: fmtNum(msgsPerDay, 1),
      subtitle: "норма живого чата: ≥50",
      color: badgeColor(msgsPerDay, 50, 20, 0, false),
    },
    {
      title: "Реакции/сообщение",
      value: stats.reactionRate.toFixed(3),
      subtitle: "норма: 0.03–0.15",
      color: badgeColor(stats.reactionRate, 0.03, 0.01, 0, false),
    },
    {
      title: "Ответы (reply)",
      value: `${fmtNum(stats.replyRate, 1)}%`,
      subtitle: "норма живого чата: >20%",
      color: badgeColor(stats.replyRate, 20, 10, 0, false),
    },
    {
      title: "Доля ботов",
      value: `${fmtNum(stats.botShare * 100, 1)}%`,
      subtitle: "норма: <10%",
      color: badgeColor(stats.botShare * 100, 10, 20, 40),
    },
    {
      title: "Ночная активность (00–07)",
      value: `${fmtNum(stats.nightShare, 1)}%`,
      subtitle: "норма: <15%",
      color: badgeColor(stats.nightShare, 15, 20, 25),
    },
    {
      title: "Дубликаты сообщений",
      value: `${fmtNum(stats.duplicateRatio, 1)}%`,
      subtitle: "норма: <10%",
      color: badgeColor(stats.duplicateRatio, 10, 20, 30),
    },
    {
      title: "Fraud Score",
      value: `${stats.fraudScore}/100`,
      subtitle: "норма: <20",
      color: badgeColor(stats.fraudScore, 20, 40, 65),
    },
  ]

  return (
    <Grid container spacing={2}>
      {cards.map((card) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={card.title}>
          <KpiCard {...card} />
        </Grid>
      ))}
    </Grid>
  )
}
